export default "__VITE_ASSET__BJS$vU2e__"